<template>
	<section>
		<div class="f-14"><strong>Detail Perjalanan</strong>            
            <button class="btn btn-custom-sec float-right hide-on-mobile" href="#modalCancel" data-toggle="modal">Batalkan</button> 
            
            <div class="barbarbar col hide-on-web">
                <div class="row">
                    <button class="col btn btn-custom-sec pd-5" href="#modalCancel" data-toggle="modal">Batalkan</button>                    
                </div>        
            </div>
        </div>
        <hr class="mt-4">
        <div class="row">
            <div class="col-2 margin-0 w-m-full no-flex pd-m-0 pd-0">
                <p class="f-14 f-m-12"><strong>Status Perjalanan</strong></p>
            </div>
            <div class="col margin-0 f-12">
                <div class="row">
                    <div class="col-2 w-m-1-2">
                        <button class="info mb-2" :class="data.status == 1 ? 'warning': data.status == 2 ? 'pickup' : data.status == 3 ? 'infoo' : data.status == 4 ? 'success' : 'warning'">{{data.col_status}}</button>
                        <p>{{ data.updated_at | moment('DD-MM-yy') }} {{data.updated_at | moment('HH:mm')}} WIB</p>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-2 margin-0 w-m-full no-flex pd-m-0 pd-0">
                <p class="f-14 f-m-12"><strong>Info</strong></p>
            </div>
            <div class="col margin-0 f-14">
                <div class="row">
                    <div class="col no-flex">
                        <p class="title-colee f-12">Tipe perjalanan</p>
                        <b>{{ data.type == 1 ? 'Loose Load' : 'Full Load'}}</b>
                    </div>
                    <div class="col no-flex">
                        <p class="title-colee f-12">Driver</p>
                        <b>{{ data.driver_main.name }}</b>
                    </div>
                    <div class="col no-flex">
                        <p class="title-colee f-12">Kendaraan</p>
                        {{ data.vehicle.type }} <br>
                        <p class="f-12 text-secondary position-absolute">{{ data.vehicle.merk }}</p>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col no-flex">
                        <p class="title-colee f-12">Tanggal perjalanan</p>
                        {{ data.created_at | moment('DD-MM-yyyy') }} {{ data.created_at | moment('HH:mm') }} WIB
                    </div>
                    <!-- <div class="col no-flex">
                        <p class="title-colee f-12">Asisten</p>
                        {{ data.driver_asistant.name}}
                    </div> -->
                    <div class="col no-flex">
                        <p class="title-colee f-12">Nomor Polisi</p>
                        <b>{{ data.vehicle.nopol }}</b>
                    </div>
                    <div class="col">
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col no-flex">
                        <p class="title-colee f-12">Kota Asal Pengiriman</p>
                        {{ data.origin.kabupaten }}
                    </div>
                    <div class="col no-flex">
                        <p class="title-colee f-12">Device</p>
                        {{ data.device.merk }}
                    </div>
                    <div class="col">
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col no-flex">
                        <p class="title-colee f-12">Kota Tujuan Pengiriman</p>
                        {{ data.destination.kabupaten }}
                    </div>
                    <div class="col no-flex">
                        <p class="title-colee f-12">Nomor Telepon</p>
                        <b>{{ data.device.phone_number }}</b>
                    </div>
                    <div class="col">
                    </div>
                </div>
            </div>    
        </div>
        <hr>
        <div class="row mb-4">
            <div class="col-2 margin-0 w-m-full no-flex pd-m-0 pd-0">
                <p class="f-14 f-m-12"><strong>Pengiriman</strong></p>
            </div>
            <div class="col margin-0 w-m-full">
                <div class="d-flex flex-wrap">
                    <div class="heuheu" v-for="(data, index) in data.list_pengiriman" :key="index">
                        <div class="row">
                            <div class="col">
                                <p class="title-colee">Nama pengirim</p><p>{{ data.pengiriman.pengirim.name }}</p>
                            </div>
                            <div class="col">
                                <p class="title-colee">Tanggal dibuat</p><p>{{ data.pengiriman.created_at | moment('DD-MM-yyyy') }} {{ data.pengiriman.created_at | moment('HH:mm') }} WIB</p>
                            </div>
                        </div>
                        <p class="title-colee">Kota asal pengiriman</p><p>{{ data.pengiriman.pengirim.address }}</p>
                        <p class="title-colee">Kota tujuan pengiriman</p><p>{{ data.pengiriman.penerima.address }}</p>
                        <div class="row">
                            <div class="col">
                                <p class="title-colee">Total barang</p><p>{{ data.pengiriman.total_barang }}</p>
                            </div>
                            <div class="col">
                                <p class="title-colee">Total berat</p><p>{{ data.pengiriman.total_berat }} KG</p>
                            </div>
                            <div class="col">
                                <p class="title-colee">Total volume</p><p>{{ data.pengiriman.total_volume | round }} m3</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <button type="button" @click="printReceipt(data.pengiriman.no_resi)" class="btn btn-primary float-left">Cetak Tanda Terima</button>
                            </div>
                            <div class="col">
                                <button type="button" @click="detail = data.pengiriman" data-toggle="modal" data-target="#modalDetailPerjalanan" class="btn btn-secondary float-right">Lihat Detail</button>
                            </div>
                        </div> 
                    </div>                    
                </div>
                <div class="mt-2 col-8" style="background-color: #ffe8cf; border-radius: 4px; font-size: 12px; padding:5px 10px;">
                    <div class="row">
                        <div class="col">
                            <p class="title-colee">Total Barang</p>
                            <b>{{ data.total_barang }}</b>
                        </div>
                        <div class="col">
                            <p class="title-colee">Total Berat</p>
                            <b>{{ data.total_berat }} KG</b>
                        </div>
                        <div class="col">
                            <p class="title-colee">Berat Volume</p>
                            <b>{{ data.total_volume | round }} m3</b>
                        </div>
                    </div>    
                </div>  
            </div>
        </div>
        <hr class="mt-4 mb-4">
        <div class="row">
            <div class="col-2 margin-0 no-flex pd-m-0 w-m-1-2">
                <p class="f-14 f-m-12 margin-0"><strong>Keterangan Tambahan</strong></p>
            </div>
            <div class="col margin-0 f-12">
                <div class="row">
                    <div class="col-6">
                        <button class="info warning mb-2">{{ data.total_berat > data.vehicle.kapasitas ? "Berat melebihi kapasitas kendaraan" : "Tidak ada" }}</button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="detail != null" class="modal fade" id="modalDetailPerjalanan" tabindex="-1" role="dialog" aria-labelledby="modalDetailPerjalananTitle" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
				<div class="modal-content mx-auto">
					<div class="modal-header">
						<h6 class="modal-title" id="modalDetailPerjalananTitle">
							<strong>Detail Pengiriman</strong>
						</h6>        
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>        
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col">
								<p class="title-colee">Nomor Resi</p>
								<b>{{detail.no_resi}}</b>
							</div>
							<div class="col">
								<p class="title-colee">Nomor Faktur</p>
								{{detail.no_faktur}}
							</div>
                            <div class="col">
								<p class="title-colee">Tipe Pengiriman</p>
								{{detail.type == 1 ? 'Kg' : 'Box'}}
							</div>							
						</div>  
						<div class="row">
							<div class="col">
								<p class="title-colee">Nama Pengirim</p>
								{{detail.pengirim.name}}
							</div>
							<div class="col">
								<p class="title-colee">Nama Penerima</p>
								{{detail.penerima.name}}
							</div>
							<div class="col">
								<p class="title-colee">Tanggal Dibuat</p>
								{{detail.created_at | moment('DD-MM-yyyy')}} {{detail.created_at | moment('HH:mm')}} WIB
							</div>
						</div> 
						<div class="row">
							<div class="col no-flex">
								<p class="title-colee">Alamat Asal Pengiriman</p>
								{{detail.pengirim.address}}
							</div>
							<div class="col no-flex">
								<p class="title-colee">Alamat Tujuan Pengiriman</p>
								{{detail.penerima.address}}
							</div>
						</div>
						<div class="row mt-4">
							<div class="heuheuheu" v-for="(data, index) in detail.barang" :key="index">
								<p class="title-colee">Nama Barang</p><p>{{data.name}}</p>
								<p class="title-colee">Berat</p><p>{{data.weight}} KG</p>
								<p class="title-colee">Berat Volume</p><p>{{data.volume | round}} m3</p>
                                <p class="title-colee">Panjang x Lebar x Tinggi</p><p>{{data.length}} cm x {{data.width}} cm x {{data.tall}} cm</p>
							</div>
						</div>  
						<div class="mt-2" style="background-color: #ffe8cf; border-radius: 4px; font-size: 12px; padding:5px 10px;">
							<div class="row">
								<div class="col">
									<p class="title-colee">Total Barang</p>
									<b>{{detail.total_barang}}</b>
								</div>
								<div class="col">
									<p class="title-colee">Total Berat</p>
									<b>{{detail.total_berat}} KG</b>
								</div>
								<div class="col">
									<p class="title-colee">Berat Volume</p>
									<b>{{detail.total_volume | round}} m3</b>
								</div>
							</div>    
						</div>       
					</div>
				</div>
			</div>
		</div>
        <div class="modal fade" id="modalCancel" tabindex="-1" role="dialog" aria-labelledby="modalConfirmPreviewTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content mx-auto">                           
                    <div class="modal-body text-center">
                        <p>Apa anda yakin membatalkan perjalanan ini?</p>
                        <div class="row justify-content-center">
                            <button class="btn btn-secondary margin-5 pd-10-20" data-dismiss="modal">Tidak</button>
                            <button @click="deleteData" class="btn btn-primary margin-5 pd-10-20" data-dismiss="modal">Ya</button>
                        </div>   
                    </div>
                </div>
            </div>
        </div>
	</section>
</template>

<script>
export default {
    name: 'ExpeditionDetail',
    data(){
        return{
            data: {
                driver_main: {},
                // driver_asistant: {},
                device: {},
                origin: {},
                destination: {},
                vehicle: {}
            },
            detail: null
        }
    },
    methods: {
        getData() {
			let _ = this
			_.axios.get('/expedition?id=' + _.$route.params.id).then(resp => {
                _.data = resp.data.data.rows
            })
            .catch(err => {
                console.log(err.response)
            })
        },
        deleteData() {
			let _ = this
			_.axios.delete('/expedition', { data: { id: _.$route.params.id } })
				.then(resp => {
					if ( resp.data.status ) {
						_.$router.push({
                            name: 'ExpeditionIndex',
                            params: {
                                status: 'delete'
                            }
                        })	
					}
				})
				.catch(err => {
					console.log(err)
					console.log(err.response)
				})
		},
        printReceipt(x){
            let _ = this

            if(localStorage.getItem('bluetooth_print') == 'true') {
                _.axios.get('/shipment/print_receipt?format=png&no_resi=' + x, {responseType: 'arraybuffer'})
                    .then(resp => {
                        let blob    = new Blob([resp.data], { type: 'image/png' })
                        
                        var reader = new FileReader();
                        reader.readAsDataURL(blob);

                        reader.onloadend = function(e) {
                            var imageBase64 = e.target.result.split(',')[1];
                            var intentUrl = "intent://print?package=com.app.bisacekprint&image=" + encodeURIComponent(imageBase64) + "#Intent;scheme=bisacekprint;end";
                            window.location.href = intentUrl;
                        };
                    })
                    .catch(err => {
                        console.log(err.response)
                    })
            }
            else {
                _.axios.get('/shipment/print_receipt?no_resi=' + x, {responseType: 'arraybuffer'})
                    .then(resp => {
                        let blob = new Blob([resp.data], { type: 'application/pdf' })
                        let link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        // link.download = 'QRCODE_' + _.data.no_resi
                        link.target = "_blank"
                        link.click()
                    })
                    .catch(err => {
                        console.log(err.response)
                    })
            }
        }
    },
    beforeMount(){
        let _ = this
        if ( _.$route.params.id ) {
			_.getData()
		}
    }
}
</script>